import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VSnackbar,{key:_vm.snackbar.shown,staticClass:"d-print-none",attrs:{"value":_vm.snackbar.show,"color":_vm.snackbar.color,"timeout":_vm.snackbar.timeout,"bottom":"","right":""},on:{"input":_vm.onSnackbarClose},scopedSlots:_vm._u([{key:"action",fn:function(ref){
var attrs = ref.attrs;
return [_c(VBtn,_vm._b({attrs:{"text":""},on:{"click":_vm.onSnackbarClose}},'v-btn',attrs,false),[_vm._v(" Close ")])]}}])},[_vm._v(" "+_vm._s(_vm.snackbar.message)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }